import React, { useState, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Title, Subtitle, AddButton } from '@components/atoms';
import { Grid, Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AuthContext from '@contexts/AuthContext';
import i18n from '@i18n';
import List from './List';
import Edit from './Edit';
import Create from './Create';

const Solicitudes = ({ location: { search }, match: { params: { action = 'list', id = '' } } }) => {
  const { pages: { customers: { solicitudes: texts } } } = i18n;
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const history = useHistory();

  const [extraInfo, setExtraInfo] = useState([]);

  const handleAddClick = () => {
    history.push('/c/solicitudes/create');
  };
  return (
    <>
      <Helmet>
        <title>{`${i18n.appName} - ${texts.title}`}</title>
      </Helmet>
      <Grid
        container
        spacing={0}
        className={classes.container}
        alignItems="center"
      >
        {texts.title && (
          <Grid item xs={12} sm={3} align="left">
            <Title>{texts.title}</Title>
          </Grid>
        )}
        {action === 'list' && user && (
        <Grid item xs={12} sm={9} align="right">
          <AddButton onClick={handleAddClick}>{texts.add}</AddButton>
        </Grid>
        )}
        {action === 'view' && (
          <Grid item xs={12} sm={9} align="right">
            {extraInfo.map((info) => <Typography noWrap>{info}</Typography>)}
          </Grid>
        )}
      </Grid>
      {texts.subtitle && (
      <Grid container spacing={0} className={classes.container}>
        <Grid item xs={12} align="left">
          <Subtitle>{texts.subtitle}</Subtitle>
        </Grid>
      </Grid>
      )}
      <Divider />
      <div className={classes.container}>
        {action === 'list' && <List search={search} />}
        {action === 'edit' && user && <Edit id={id} setExtraInfo={setExtraInfo} />}
        {action === 'create' && user && <Create user={user} />}

      </div>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  mt1: {
    marginTop: '1em',
  },
  container: {
    padding: theme.spacing(3),
  },
}));

Solicitudes.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      action: PropTypes.string,
      id: PropTypes.string,
    }),
  }),
};

Solicitudes.defaultProps = {
  location: {
    search: '',
  },
  match: {
    params: {
      action: 'list',
      id: '',
    },
  },
};

export default Solicitudes;
